import axios from "axios";
import React, { useState, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next";
function ContactSection(props) {
    const { t, i18n } = useTranslation('common');
    
    let rem_address_val = props?.MetaData?.rem_address
    if (rem_address_val != undefined) {
        try {
            rem_address_val = JSON.parse(rem_address_val)
        } catch (e) {
        }
    }
    const [address_val, setaddress_val] = useState(rem_address_val);

    var icon1 = props.site_url + "/wp-content/uploads/2022/07/noun-map-pin-4966787.png";
    var icon2 = props.site_url + "/wp-content/uploads/2022/07/noun-map-pin-4966787-1.png";
    function initMap() {
        if (!window.google) {
            setTimeout(function () {
                initMap();
            }, 1000);
            return false;
        }
        const lat = (props?.MetaData?.rem_latitude) ? props?.MetaData?.rem_latitude[0] : '';
        const long = (props?.MetaData?.rem_longitude) ? props?.MetaData?.rem_longitude[0] : '';
        var center = { 'lat': parseFloat(lat), 'lng': parseFloat(long) };
       

        if (document.getElementById('googleMap') == null) {
            setTimeout(function () {
                initMap();
            }, 1000);
            return false;
        }
        var map = new google.maps.Map(document.getElementById('googleMap'), {
            zoom: 13,
            center: center,
            mapTypeControl: false,
            fullscreenControl: false,
            styles: [
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f7f1df"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#d0e3b4"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.medical",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#fbd3da"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.bus",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffe15f"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#efd151"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#686868"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#8c7f7f"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#cfb2db"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#00b3ff"
                        }
                    ]
                }
            ]
        });
        var infowindow = new google.maps.InfoWindow({});
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, long),
            map: map,
            // title: locations[count][0],
            icon: icon1,
        });
        // marker_details.push(marker);
        // google.maps.event.addListener(marker, 'click', (function (marker, count) {
        //     return function () {
        //         infowindow.open(map, marker);
        //     }
        // })(marker));
        google.maps.event.addListener(marker, 'mouseover', function () {
            this.setIcon(icon2);
        });
        google.maps.event.addListener(marker, 'mouseout', function () {
            this.setIcon(icon1);
        });
    }
    function set_url(path) {
        return props?.site_url+path;
    }
    function contact_form(event) {
        event.preventDefault();
        const regex = /^[a-zA-Z ]*$/;
        const regex_num = /^[+]?[0-9]+$/;
        const regex_email = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const name = document.querySelector(".rem_form #name").value;
        const phone = document.querySelector(".rem_form #phone").value;
        const email = document.querySelector(".rem_form #email").value;
        const message = document.querySelector(".rem_form #message").value;
        const ProfessionalUserID = document.querySelector(".rem_form #ProfessionalUserID").value;


        if (!regex.test(name)) {
            jQuery('.contact-errortxtMessage ').html("Please enter your name properly.");
            document.getElementById('rem_form_success_msg').innerHTML = "";
            return;

        } else {
            jQuery('.contact-errortxtMessage ').html("");
        }
        if (!regex_num.test(phone)) {
            jQuery('.contact-errorphoneMessage').html("Please enter valid phone number ");
            document.getElementById('rem_form_success_msg').innerHTML = "";
            return;
        }
        else {
            jQuery('.contact-errorphoneMessage').html("");
        }
        if (!regex_email.test(email)) {

            jQuery('.contact-erroremailMessage').html("Please Fill Valid Email ");
            document.getElementById('rem_form_success_msg').innerHTML = "";

            return;
        }
        else {
            jQuery('.contact-erroremailMessage').html("");
        }
        const data = {
            'rem_name': name,
            'contact_no': phone,
            'contact_email': email,
            'rem_message': message,
            'ProfessionalUserID': ProfessionalUserID,
        };
        axios.post(set_url('/wp-json/myapi/v1/contact_form'), data)
            .then(response => {

                if (response?.data?.error == false) {
                    document.getElementById('rem_form_success_msg').innerHTML = "Form submitted successfully";
                    event.target.reset()
                }
            });

    }
    function address_pag_right(e) {
        var data = jQuery(e.target).parent().parent().parent().find('h5')[0].style.display = "block";
        var data = jQuery(e.target).parent().parent().parent().find('h5')[1].style.display = "none";
        var data1 = jQuery(e.target).parent().parent().find('p')[1].style.display = "block";
        var data1 = jQuery(e.target).parent().parent().find('p')[2].style.display = "none";
    }
function address_pag_left(e) {
    var data = jQuery(e.target).parent().parent().parent().find('h5')[1].style.display = "block";
    var data = jQuery(e.target).parent().parent().parent().find('h5')[0].style.display = "none";
    var data1 = jQuery(e.target).parent().parent().find('p')[1].style.display = "none";
    var data1 = jQuery(e.target).parent().parent().find('p')[2].style.display = "block";
}

    return (<section class="goggle_map_section rem_nav_section" id="contact_section">
        <div class="container_size">
            <div class="form_map-main">
                <div class="map_box">
                    <h3 class="map-text">{t('Map')}</h3>
                    <div id="googleMap"></div>
                    {initMap()}
                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158858.182370726!2d-0.10159865000000001!3d51.52864165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sin!4v1659511901344!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

                    <div class="map_slide_details">
                        {
                            (address_val?.[1]) ?
                                <h5 id="data_add2" >{(address_val?.[1]) ? address_val?.[1] : ''}</h5>
                                : <h5 id="data_add2">{(address_val?.[0]) ? address_val?.[0] : ''}</h5>
                        }
                        {
                            (address_val?.[0]) ?
                                <h5 id="data_add1">{(address_val?.[0]) ? address_val?.[0] : ''}</h5>
                                : ''
                        }
                        {(address_val?.[0]) ?
                            <div class="slide_btn_map">
                                <p><i class="fa-solid fa-angle-left" onClick={address_pag_left}></i></p>
                                {
                                    (address_val?.[1]) ?
                                        <p id="page_hide">2 of 2 </p>
                                        : <p id="page_hide">1 of 2 </p>

                                }
                                {(address_val?.[1]) ?
                                    <p>1 of 2 </p>
                                    : <p>1 of 1 </p>
                                }
                                {(address_val?.[1]) ?
                                    <p><i class="fa-solid fa-angle-right" onClick={address_pag_right}></i></p>
                                    :  <p><i class="fa-solid fa-angle-right" onClick=""></i></p>
                                }
                            </div>
                            : ''
                        }
                    </div>

                    {
                        (address_val?.[0]) ?
                            <p class="mobile-screen_hide"><img src={set_url("/wp-content/uploads/images/ic_place.png")} alt="" />{(address_val?.[0]) ? address_val?.[0] : ''}</p>
                            : ''
                    }
                    {
                        (address_val?.[1]) ?
                            <p class="mobile-screen_hide"><img src={set_url("/wp-content/uploads/images/Shield-Done.png")} alt="" />{(address_val?.[1]) ? address_val?.[1] : ''}</p>
                            : ''
                    }
                </div>

                <div class="Form_box">
                    <h3 class="map-text">{t('Contact Form')}</h3>
                    <form class="rem_form" onSubmit={contact_form} autocomplete="off" id="user_contact_form">
                        <div class="contact-errortxtMessage error_msg_contact"></div>
                        <input type="text" id="name" placeholder={t('Name')} name="rem_name" required />
                        <div class="contact-errorphoneMessage error_msg_contact"></div>
                        <input type="text" id="phone" name="contact_no" placeholder={t('Phone')} required maxlength="15" />
                        <div class="contact-erroremailMessage error_msg_contact"></div>
                        <input type="email" id="email" name="contact_email" placeholder="E-mail" required />
                        <input type="hidden" id="ProfessionalUserID" name="ProfessionalUserID" value={props?.data?.ID} />
                        <textarea id="message" rows="4" placeholder={t('Message')} name="rem_message"></textarea>

                        <button type="submit">{t('Send')}</button>
                    </form>
                    <div id='rem_form_success_msg'></div>
                </div>


            </div>
        </div>
    </section>);
}

export default ContactSection;